import { Flex } from '@lemonade-hq/cdk';
import type { Locale } from '@lemonade-hq/lemonation';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import type React from 'react';
import styled from 'styled-components';
import { RegionMap } from './RegionMap';
import { AVAILABLE_PLACES } from './consts';
import EUPolygons from './eu.json';
import USPolygons from './us.json';

const MapsContainer = styled(Flex)`
  width: 100%;
  margin-bottom: 57px;
  position: relative;

  ${MEDIA_QUERIES.tabletAndDesktop`
        max-width: 1100px;
    `}

  > * {
    &:not(:last-child) {
      margin-bottom: 26px;

      ${MEDIA_QUERIES.tabletAndDesktop`
                margin-right: 26px;
            `}
    }
  }
`;

export const GlobalMap: React.FC<{ locale: Locale }> = ({ locale }) => {
  return (
    <MapsContainer
      px={[20, 36]}
      mt={[80, 100]}
      flexDirection={['column', 'row']}
      alignItems="baseline"
      justifyContent={['flex-start', 'space-around']}
    >
      <RegionMap
        locale={locale}
        regionCode="us"
        viewBox="0 0 919 583"
        polygons={USPolygons}
        highlightedPlaces={AVAILABLE_PLACES.us as unknown as string[]}
        tooltipTransform={{
          mi: { x: 10, y: 10 },
          md: { x: 15, y: -5 },
          ma: { x: 0, y: -10 },
          ct: { x: 0, y: -10 },
          nj: { x: 2, y: -10 },
          ri: { x: -1, y: -10 },
          fl: { x: 25, y: 0 },
          hi: { x: 20, y: 0 },
        }}
      />
      <RegionMap
        regionCode="eu"
        viewBox="0 0 503 348"
        polygons={EUPolygons}
        highlightedPlaces={AVAILABLE_PLACES.eu as unknown as string[]}
        locale={locale}
      />
    </MapsContainer>
  );
};
